<template>
  <div class="page page-home">
    <div class="banner">
      <img src="@/assets/images/home/banner.png" />
    </div>
    <div class="project">
      <div class="Modeling-activity">
        <cmp-page-title
          name="2026 年全国青少年科学探究建模能力大赛分赛项 —— 建模能力赛"
        />
        <div class="width-870" v-if="step < 2">
          <el-row type="flex" justify="center">
            <!-- <div class="activity-btn activity-btn-primary" @click="activityBtnClick">团体报名入口</div> -->
            <div
              class="activity-btn activity-btn-success"
              @click="activityBtnClick2"
            >
              身份校验入口
            </div>
          </el-row>
          <p class="text-center">
            <!-- 身份校验入口开放时间：{{
              identityCheckInfo.startTime | formatDate
            }}—{{ identityCheckInfo.endTime | formatDate }} -->
            身份校验入口开放时间：2026年1月15日（周四）8:00—2026年1月24日（周六）18:00
          </p>
          <p class="text-center" v-if="showMoniText">
            模拟测试时间:2026年1月18日(周日)上午9:30-10:30，考试入口（https://exam.jsxfedu.com/sxjm）
          </p>
          <p class="text-center text-danger">
            注：考试时建议使用当前已通过身份校验的设备，
            若计划使用其他设备考试，须在身份校验结束（1月24日18:00）之前，于新设备上提前完成身份校验流程。如因更换设备而导致无法正常考试或影响考试成绩，后果须自负。
          </p>
        </div>
        <div class="width-870" v-else-if="step === 2">
          <h2>初赛即将开始</h2>
          <p class="text-center">
            初赛考试入口（https://exam.jsxfedu.com/sxjm）将于2026年2月1日（周日）上午
            09:00开启，
          </p>
          <p class="text-center">
            请于09:00-09:30进行考前验证，09:30-10:30进行线上答题。
          </p>
          <p class="text-center text-danger">
            注：考试时建议使用当前已通过身份校验的设备，
            若计划使用其他设备考试，须在身份校验结束（1月24日18:00）之前，于新设备上提前完成身份校验流程。如因更换设备而导致无法正常考试或影响考试成绩，后果须自负。
          </p>
        </div>
        <div class="width-870" v-else-if="step === 3">
          <p class="text-center">初赛测试入口 https://exam.jsxfedu.com/sxjm</p>
          <p class="text-center">
            测试入口开启时间：2026年2月1日（周日）上午9:00-10:30
          </p>
          <p class="text-center text-danger">
            注：考试时建议使用当前已通过身份校验的设备，
            若计划使用其他设备考试，须在身份校验结束（1月24日18:00）之前，于新设备上提前完成身份校验流程。如因更换设备而导致无法正常考试或影响考试成绩，后果须自负。
          </p>
        </div>
        <div class="width-870" v-else-if="step === 4">
          <h2>成绩判定中</h2>
          <p class="text-center">
            2026年2月10日可查询初赛结果，祝您取得好成绩。
          </p>
        </div>
        <div class="width-870 text-center" v-else-if="step === 5">
          <el-row type="flex" justify="center">
            <div
              class="activity-btn activity-btn-success"
              @click="scorequeryClick"
            >
              成绩查询
            </div>
            <div
              class="activity-btn activity-btn-primary"
              @click="papersubmitClick"
            >
              论文提交
            </div>
          </el-row>
          <p>初赛电子证书下载功能暂未开放，开放时间另行通知</p>
          <p>
            复赛论文提交入口开放时间：2026年2月10日（周二）—2026年4月15日（周三）
          </p>
        </div>
        <div class="width-870 text-center" v-else-if="step === 6">
          <el-row type="flex" justify="center">
            <div
              class="activity-btn activity-btn-success"
              @click="scorequeryClick"
            >
              成绩查询
            </div>
            <div
              class="activity-btn activity-btn-primary"
              @click="paperqueryClick"
            >
              论文查询
            </div>
          </el-row>
          <p>初赛电子证书下载功能暂未开放，开放时间另行通知</p>
        </div>
        <div class="width-870" v-else-if="step > 6">
          <h2>活动已结束</h2>
        </div>
      </div>
    </div>
    <!-- 身份验证 -->
    <el-dialog
      :title="step === 0 ? '提示' : '身份验证'"
      :visible.sync="dialogVisible"
      width="620px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div v-if="step === 0">还没到身份校验时间，请耐心等待。</div>
      <el-form
        v-else-if="step === 1"
        :model="Form"
        :rules="rules"
        label-width="125px"
        ref="ruleForm"
      >
        <el-form-item label="姓名" prop="studentName">
          <el-input
            v-model.trim="Form.studentName"
            :maxlength="100"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input
            v-model.trim="Form.phone"
            :maxlength="11"
            placeholder="请输入报名时填写的手机号码(非大陆号码需加区号，只写数字)"
          ></el-input>
        </el-form-item>
        <el-form-item label="证件号码后六位" prop="lastSixIdNumber">
          <el-input
            v-model.trim="Form.lastSixIdNumber"
            :maxlength="6"
            placeholder="请输入证件号码后六位(港澳证件不带括号)"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取消</el-button>
        <el-button type="primary" @click="dialogConfirm">确定</el-button>
      </span>
    </el-dialog>
    <!-- 验证结果 -->
    <el-dialog
      :title="
        dialogResult === 0
          ? '未查询到报名信息'
          : '您已成功报名2026 年全国青少年科学探究建模能力大赛分赛项 —— 建模能力赛（初赛）'
      "
      :visible.sync="dialogResultVisible"
      width="540px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div v-if="dialogResult === 0">
        <p>请核验您的姓名、手机号码、证件号码后六位是否填写正确。</p>
        <p>若信息无误，请联系学校报名老师确认报名情况。</p>
      </div>
      <div v-else-if="dialogResult === 1" class="text-left">
        <p>姓名：{{ studentInfo.studentName }}</p>
        <p>性别：{{ sexDict[studentInfo.sex] }}</p>
        <p>学校：{{ studentInfo.schoolName }}</p>
        <p>年级：{{ gradeDict[studentInfo.grade] }}</p>
        <p>
          注：活动期间将全程开启摄像头，请使用带摄像头的台式机或笔记本参加活动。推荐使用Windows7及以上系统的电脑最新版本360浏览器或谷歌浏览器访问，请勿使用IE浏览器。
        </p>
        <p class="text-center">
          为了确保考试顺利进行，请您调试摄像头并进行答题检测。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="dialogResult === 0"
          type="primary"
          @click="dialogResultVisible = false"
          >确定</el-button
        >
        <el-button
          v-else-if="dialogResult === 1"
          type="primary"
          @click="debugCamera"
          >调试摄像头</el-button
        >
      </span>
    </el-dialog>
    <!-- 调试摄像头 -->
    <cmpCameraPopper ref="cmpCameraPopper"></cmpCameraPopper>
    <!-- 查询成绩 -->
    <cmpDialogScorequery ref="cmpDialogScorequery"></cmpDialogScorequery>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import cmpPageTitle from '@/components/cmp-page-title';
import cmpCameraPopper from '@/components/cmp-camera-popper';
import cmpDialogScorequery from '@/components/cmp-dialog-scorequery';
import sxjmApi from '@/api/sxjm-api.js';
import api from '@/api/index.js';
import { formatDate } from 'jstools-common/dist/jstools.web';
import { EventBus } from '@/assets/scripts/bus';

export default {
  name: 'page-home',
  components: {
    cmpPageTitle,
    cmpCameraPopper,
    cmpDialogScorequery,
  },
  data() {
    // 校验中文字符最少两位最大15位包含·
    let ChineseRules = function (rule, value, callback) {
      // const reg = /^[\u4e00-\u9fa5·]{2,15}$/;
      if (!value) {
        return callback(new Error('请输入姓名'));
        // } else if (!reg.test(value)) {
        //   return callback(new Error('您的姓名不符合规则，请修改后再试'));
      } else {
        callback();
      }
    };
    let idRules = function (rule, value, callback) {
      // const reg = /^[0-9A-Za-z(（)）]{6}$/;
      const reg = /^[0-9A-Za-z]{6}$/;
      if (!value) {
        return callback(new Error('请输入证件号码后六位'));
      } else if (!reg.test(value)) {
        return callback(new Error('证件号码后六位不符合规则，请修改后再试'));
      } else {
        callback();
      }
    };
    return {
      activityList: [],
      Form: {
        studentName: '',
        phone: '',
        lastSixIdNumber: '',
      },
      rules: {
        studentName: [
          { required: true, validator: ChineseRules, trigger: 'change' },
        ],
        phone: [
          {
            required: true,
            message: '请输入报名时填写的手机号码',
            trigger: 'change',
          },
        ],
        lastSixIdNumber: [
          { required: true, validator: idRules, trigger: 'change' },
        ],
      },
      dialogVisible: false,
      step: 5,
      dialogResultVisible: false,
      dialogResult: 0,
      studentInfo: {},
      serverTime: Date.now(),
    };
  },
  computed: {
    ...mapState(['activityActive', 'sexDict', 'gradeDict']),
    ...mapGetters(['isLogined']),
    identityCheckInfo() {
      let schedulers = this.activityActive.schedulers || [];
      let result = schedulers.filter((item) => item.stage === 'IDENTITY_CHECK');
      return result[0] || {};
    },
    examInfo() {
      let schedulers = this.activityActive.schedulers || [];
      let result = schedulers.filter((item) => item.stage === 'EXAM');
      return result[0] || {};
    },
    queryExamScoreInfo() {
      let schedulers = this.activityActive.schedulers || [];
      let result = schedulers.filter(
        (item) => item.stage === 'QUERY_EXAM_SCORE',
      );
      return result[0] || {};
    },
    submitPaperInfo() {
      let schedulers = this.activityActive.schedulers || [];
      let result = schedulers.filter(
        (item) => item.stage === 'SUB_PAPER',
      );
      return result[0] || {};
    },
    showMoniText() {
      let _moniend = new Date('2026-01-18 10:30:00').getTime();
      return this.serverTime < _moniend;
    },
  },
  filters: {
    formatDate(val) {
      let str = formatDate(val, 'yyyy年MM月dd日（星期几）hh:mm') || '~';
      let _val = new Date(val);
      str = str.replace(/星期几/g, '周' + '日一二三四五六'[_val.getDay()]);
      return str;
    },
  },
  async mounted() {
    // await this.getServerTime();
    // await this.getActivityDetailsPage();
    // this.initStatus();
    this.getServerTime().then(() => {
      this.initStatus();
      this.getActivityDetailsPage();
    }).catch((err) => {
      console.error('获取服务器时间失败:', err);
      this.initStatus();
      this.getActivityDetailsPage();
    });
  },
  methods: {
    ...mapMutations(['setActivityActive', 'setUserInfo']),
    getServerTime() {
      return api
        .getServerTime()
        .then((res) => {
          this.serverTime = parseInt(res) || Date.now();
        })
        .catch((err) => {
          console.error('获取服务器时间失败:', err);
        });
    },
    getActivityDetailsPage() {
      return sxjmApi
        .getActivityDetailsPage({
          pageNo: 1,
          pageSize: 4,
          type: 2,
          year: '',
        })
        .then((res) => {
          this.activityList = res.result || [];
          let activityActive = this.activityList[0] || {};
          this.setActivityActive(activityActive);
        });
    },
    activityBtnClick() {},
    async activityBtnClick2() {
      await this.getServerTime();
      // this.initStatus();
      this.dialogVisible = true;
    },
    initStatus() {
      let _now = this.serverTime;
      // let _start = new Date(this.identityCheckInfo.startTime).getTime();
      // let _end = new Date(this.identityCheckInfo.endTime).getTime();
      let _start = new Date('2026-01-15 08:00:00').getTime();
      let _end = new Date('2026-01-24 18:00:00').getTime();
      // let _start1 = new Date(this.examInfo.startTime).getTime() - 60 * 60 * 1000;
      // let _end1 = new Date(this.examInfo.endTime).getTime();
      let _start1 = new Date('2026-02-01 08:31:00').getTime();
      let _end1 = new Date('2026-02-01 10:30:00').getTime();
      // let _start2 = new Date(this.queryExamScoreInfo.startTime).getTime();
      // let _end2 = new Date(this.queryExamScoreInfo.endTime).getTime();
      let _start2 = new Date('2026-02-10 00:00:00').getTime();
      let _end2 = new Date('2026-04-15 23:59:59').getTime();
      if (_now < _start) {
        this.step = 0;
      } else if (_now <= _end) {
        this.step = 1;
      } else if (_now <= _start1) {
        this.step = 2;
      } else if (_now <= _end1) {
        this.step = 3;
      } else if (_now < _start2) {
        this.step = 4;
      } else if (_now <= _end2) {
        this.step = 5;
      // } else if (_now >= _start1 && _now <= _end1) {
      //   this.step = 3;
      // } else if (_now > _end1 && _now < _start2) {
      //   this.step = 4;
      // } else if (_now >= _start2 && _now <= _end2) {
      //   this.step = 5;
      } else if (_now > _end2) {
        this.step = 6;
      }
    },
    dialogCancel() {
      this.dialogVisible = false;
    },
    dialogConfirm() {
      if (this.step === 0) {
        this.dialogCancel();
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return false;
        // let lastSixIdNumber = this.Form.lastSixIdNumber.replace(
        //   /[（（））]/g,
        //   (match) => (match === '（' ? '(' : ')')
        // );
        let lastSixIdNumber = this.Form.lastSixIdNumber.replaceAll(
          /[（（））]/g,
          '',
        );
        this.studentInfo = {};
        sxjmApi
          .validIdentity({
            activityId: this.identityCheckInfo.activityId,
            schedulerId: this.identityCheckInfo.schedulerId,
            phone: this.Form.phone,
            studentName: this.Form.studentName,
            lastSixIdNumber,
          })
          .then((res) => {
            res = res || {};
            if (res.code === 0 && res.data) {
              this.studentInfo = res.data || {};
              this.dialogResult = 1;
              this.dialogVisible = false;
              this.dialogResultVisible = true;
            } else if (!res.data) {
              this.studentInfo = {};
              this.dialogResult = 0;
              this.dialogVisible = false;
              this.dialogResultVisible = true;
            } else {
              this.$message.error(res.msg || '请求错误');
            }
            localStorage.setItem('STU_UID', this.studentInfo.stuUid || '');
            localStorage.setItem(
              'token',
              (this.studentInfo.accessToken || {}).token || '',
            );
            // localStorage.setItem('token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJqc3hmIiwiZXhwIjoxNzczMDQ1ODg3LCJ1c2VyIjoie1wiY2xpZW50SWRcIjpcIjIwMjAwMDJcIixcImlkXCI6XCI2NzE4MDAxXCIsXCJsb2dpblRpbWVzdGFtcFwiOjE3Njc4NjE4ODcwMTksXCJyZWFsbmFtZVwiOlwi5a2f56Wl5a64XCIsXCJzaWdcIjpcIlltTTBaVGM1WW1NMlpERXpOVGRqWXpRMVptTmxZMkl4T0RGbU1tRmtZMlE2TWpBeU1EQXdNam94TnpZM09EWXhPRGcyTWpNMVwiLFwidXNlcklkVHlwZVwiOlwiUEFTU1BPUlRfQUNDT1VOVFwiLFwidXNlcm5hbWVcIjpcIjY3MTgwMDFcIn0ifQ.y1t9Jw7SeugXh9wus6GKnFVuCd05zn0C8I-816QQeJY');
            this.setUserInfo(this.studentInfo);
          })
          .catch((error) => {
            if (error.code === 3) {
              this.studentInfo = {};
              this.dialogResult = 0;
              this.dialogVisible = false;
              this.dialogResultVisible = true;
              // this.$confirm(
              //   '无查询结果，请核验您的姓名、手机号码、证件号码后六位是否填写正确。',
              //   '提示',
              //   {
              //     confirmButtonText: '确定',
              //     showClose: false,
              //     showCancelButton: false,
              //     closeOnClickModal: false,
              //     type: 'warning',
              //   }
              // );
              return false;
            }
            localStorage.setItem('STU_UID', this.studentInfo.stuUid || '');
            localStorage.setItem('token', '');
            this.setUserInfo(this.studentInfo);
            this.$message.error(error.msg);
          });
      });
    },
    dialogReset() {
      this.Form = {
        studentName: '',
        phone: '',
        lastSixIdNumber: '',
      };
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
    },
    debugCamera() {
      this.dialogResultVisible = false;
      this.$refs.cmpCameraPopper && this.$refs.cmpCameraPopper.openCameraBtn();
    },
    scorequeryClick() {
      this.$refs.cmpDialogScorequery && this.$refs.cmpDialogScorequery.show();
    },
    papersubmitClick() {
      if (!this.isLogined) {
        EventBus.$emit('loginShow');
        return false;
      }
      this.$router.push({
        name: 'papersubmit-agreement',
        query: {
          activityId: this.submitPaperInfo.activityId,
          user: this.activityActive.type,
        },
      });
    },
    paperqueryClick() {
      if (!this.isLogined) {
        EventBus.$emit('loginShow');
        return false;
      }
      this.$router.push({
        name: 'papersubmit-query',
        query: {
          activityId: this.submitPaperInfo.activityId,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  position: relative;
  overflow: hidden;
  height: 400px;
  background: #fff;
  img {
    display: block;
    width: auto;
    height: 100%;
    margin: 0 auto;
    // position: absolute;
    // left: 50%;
    // -webkit-transform: translateX(-50%);
    // transform: translateX(-50%);
  }
}
h2 {
  font-size: 28px;
  font-weight: 500;
}
.width-870 {
  width: 870px;
  margin: 0 auto;
}
.activity-btn {
  display: inline-block;
  margin: 20px;
  padding: 10px 50px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  line-height: 2.5;
  cursor: pointer;
  &.activity-btn-primary {
    color: #349aff;
    border: 2px solid #349aff;
  }
  &.activity-btn-success {
    color: #0dd27e;
    border: 2px solid #0dd27e;
  }
}
/deep/ .el-dialog__body {
  padding: 10px 30px;
}
</style>
